import { useEffect, useState } from 'react';

export const useMinimumLoaderTime = (duration: number = 1000) => {
  const [isMinimumTime, setIsMinimumTime] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsMinimumTime(false);
    }, duration);

    return () => clearTimeout(timer);
  }, [duration]);

  return isMinimumTime;
};
